import { DisplayOnlyField } from "components/Forms/DisplayOnlyField";
import { ComponentProps } from "react";

/**
 * DisplayOnlyField with 8px label spacing and wrapping values for the V2 facility profile.
 */
export function V2DisplayOnlyField(props: ComponentProps<typeof DisplayOnlyField>) {
  return <DisplayOnlyField labelSpacing={1} wrapValue {...props} />;
}
